export default __webpack_public_path__ + "static/media/Energy_demand_bg.84295524.jpg";